import * as React from 'react';
import * as intl from 'react-intl-universal';
import { compact } from 'lodash';
import * as classes from './EnterPresenterCode.scss';
import LoadingSpinner from './LoadingSpinner';

export interface Props {
  onAuthenticationEdit: any;
  onSubmit: any;
  submitError: string;
  isAuthenticating: boolean;
}

interface State {
  formEdited: boolean;
  linkingCode: string;
}

const maxFieldLength: number = 6;

class EnterPresenterCode extends React.Component<Props, State> {
  public state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      formEdited: false,
      linkingCode: ''
    };
  }

  onInputChange = (event: any) => {
    if (!this.state.formEdited) {
      this.props.onAuthenticationEdit();
    }
    if (event.target.value.length <= maxFieldLength) {
      this.setState({
        formEdited: true,
        linkingCode: event.target.value.substr(0, maxFieldLength)
      });
    }
  }

  onSubmit = (event: any) => {
    event.preventDefault();
    this.props.onSubmit(this.state.linkingCode);
    this.setState({
      formEdited: false
    });
  }

  getDisabled = () => {
    return !this.state.linkingCode || this.props.isAuthenticating;
  }

  getButtonContent = () => {
    if (this.props.isAuthenticating) {
      return <LoadingSpinner isSmall={true}/>;
    }

    return intl.get('button_present');
  }

  render() {
    const formError = (!this.state.formEdited && this.props.submitError)
      || '';
    const inputClasses = compact([classes.inputContainer, formError ? classes.hasError : '']).join(' ');

    return (
      <div className={classes.content}>
        <h2 className={classes.title}>{intl.get('title_present')}</h2>
        <h4 className={classes.subTitle}>{intl.get('subtitle_check_for_code')}</h4>
        <form
          autoComplete="off"
          name="present"
          onSubmit={this.onSubmit}
        >
          <div className={inputClasses}>
            <input
              autoComplete="off"
              autoFocus
              name="linkingCode"
              onChange={this.onInputChange}
              placeholder={intl.get('placeholder_enter_code')}
              value={this.state.linkingCode}
            />
            {formError && (
              <span className={`icon icon-exclamation ${classes.icon}`} />
            )}
          </div>
          <button type="button" disabled={this.getDisabled()} onClick={this.onSubmit}>
            {this.getButtonContent()}
          </button>
        </form>
        {formError && (
          <div className={`${classes.error} font-size-xs`}>
            {formError}
          </div>
        )}
      </div>
    );
  }
}

export default EnterPresenterCode;



// WEBPACK FOOTER //
// ./src/components/EnterPresenterCode.tsx